import { render, staticRenderFns } from "./AssetAppendixNew.vue?vue&type=template&id=7022010c"
import script from "./AssetAppendixNew.vue?vue&type=script&lang=js"
export * from "./AssetAppendixNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports